const IS_EQUAL_TO = { '=': $localize`:@@preset.is_equal_to:is equal to` };
const IS_NOT_EQUAL_TO = { '!=': $localize`:@@preset.is_not_equal_to:is not equal to` };
const IS_GREATER_THAN = { '>': $localize`:@@preset.is_greater_than:is greater than` };
const IS_LESS_THAN = { '<': $localize`:@@preset.is_less_than:is less than` };
const IS_GREATER_OR_EQUAL_THAN = { '>=': $localize`:@@preset.is_greater_or_equal_than:is greater or equal than` };
const IS_LESS_OR_EQUAL_THAN = { '<=': $localize`:@@preset.is_less_or_equal_than:is less or equal than` };
const CONTAINED_IN = { IN: $localize`:@@preset.contained_in:contained in` };
const NOT_CONTAINED_IN = { 'NOT IN': $localize`:@@preset.not_contained_in:not contained in` };
const CONTAINS = { LIKE: $localize`:@@preset.contains:contains` };
const NOT_CONTAINS = { 'NOT LIKE': $localize`:@@preset.not_contains:not contains` };
const NOT_CONTAINED_IN_PQL = { NOT_IN: $localize`:@@preset.not_contained_in_pql:not contained in` };
const INCLUDES = { includes: $localize`:@@preset.includes:includes` };
const EXCLUDES = { excludes: $localize`:@@preset.excludes:excludes` };
const START_WITH = { start_with: $localize`:@@preset.start_with:start with` };

export {
  IS_EQUAL_TO,
  IS_NOT_EQUAL_TO,
  IS_GREATER_THAN,
  IS_LESS_THAN,
  IS_GREATER_OR_EQUAL_THAN,
  IS_LESS_OR_EQUAL_THAN,
  CONTAINED_IN,
  NOT_CONTAINED_IN,
  CONTAINS,
  NOT_CONTAINS,
  NOT_CONTAINED_IN_PQL,
  INCLUDES,
  EXCLUDES,
  START_WITH,
};
